import {
  Arrange,
  Button,
  Icon,
  IconButton,
  Spacer,
  SvgClose,
  SvgSparkle,
  Text,
} from '@loomhq/lens';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import {
  FTUX_TOOLTIP_DISMISSED,
  FTUX_TOOLTIP_RENDERED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';

import styles from './styles.module.less';

export const FTUX_LAAG_OPTIONS = {
  triggerOffset: 10,
  containerOffset: 10,
  isOpen: true,
  auto: true,
  snap: true,
};

export default function FTUXTooltip({
  variant,
  title,
  subtitle,
  dismissTooltip,
  expanded = false,
  source = null,
  variantClassOverride = null,
}) {
  const [collapsedTooltip, setCollapsedTooltip] = useState(!expanded);

  useEffect(() => {
    analytics.track(FTUX_TOOLTIP_RENDERED, { source });
  }, [source]);

  return collapsedTooltip ? (
    <Button
      className={classnames(
        variantClassOverride || (variant && styles[variant]),
        styles.pill,
        'ellipsis',
        variantClassOverride
      )}
      aria-label="New Feature Info - Click to Open"
      variant="upgrade"
      onClick={() => {
        setCollapsedTooltip(!collapsedTooltip);
      }}
      icon={<SvgSparkle />}
      iconPosition="left"
    >
      <Text fontWeight="bold" size="small">
        New
      </Text>
    </Button>
  ) : (
    <div
      className={classnames(
        variant && styles[variant],
        styles.expanded,
        variantClassOverride
      )}
    >
      <div className="absolute top:0 right:0 pt:xsmall pr:xsmall">
        <IconButton
          size="small"
          altText="Dismiss"
          icon={<SvgClose />}
          iconColor="currentColor"
          onClick={() => {
            analytics.track(FTUX_TOOLTIP_DISMISSED, { source });
            dismissTooltip();
          }}
        />
      </div>
      <div className="p:medium">
        <Arrange gap={0.75}>
          <Icon icon={<SvgSparkle />} color="currentColor" size={2} />
          <Text fontWeight="bold" size="small" color="currentColor">
            {title}
          </Text>
        </Arrange>
        <Spacer top={1.5} />
        <Text size="small">{subtitle}</Text>
      </div>
    </div>
  );
}
